/**
 * Message d'annulation par défaut (Markdown) — modifiable depuis l'admin.
 */
export const DEFAULT_CANCELLATION_MESSAGE = `Suite à la décision de la mairie de maintenir le gymnase fermé dans le cadre de l'épisode de canicule, nous sommes malheureusement **contraints d'annuler** le tournoi national de SQY PING prévu ce week-end.

Nous vous remercions pour votre compréhension face à cette situation indépendante de notre volonté.

---

### 💳 Remboursement des inscriptions

L'ensemble des inscriptions sera **intégralement remboursé**.

Les remboursements seront lancés dans les prochains jours et devraient apparaître sur votre compte bancaire dans un délai maximal d'environ **deux semaines**.

*Aucune démarche n'est nécessaire de votre part.*

---

### 📅 Le tournoi sera reprogrammé !

Le tournoi sera reprogrammé le **XX/XX/2026**.

Les joueurs inscrits à cette édition bénéficieront d'une **priorité d'inscription**.

Vous recevrez un e-mail quelques jours avant l'ouverture des inscriptions aux autres joueurs afin de pouvoir réserver votre place en priorité.

Nous espérons sincèrement pouvoir vous retrouver à cette occasion.

---

Encore toutes nos excuses pour cette annulation et merci pour votre compréhension.

**Sportivement,**  
*L'équipe SQY PING* 🏓`;
